import { c as _c } from "react/compiler-runtime";
import type { ColumnFiltersState } from '@tanstack/react-table';
import { useMemo } from 'react';
import type { DashboardEarnPositionsFilters } from '@/helpers/filter/table';
import type { DashboardEarnPositionsTableRow } from '../config/DashboardEarnPositionsTable.types';
interface DashboardEarnPositionsFiltersProps {
  items: DashboardEarnPositionsTableRow[];
  columnFilters: ColumnFiltersState;
}
export const useDashboardEarnPositionsFilters = t0 => {
  const $ = _c(19);
  const {
    items,
    columnFilters
  } = t0;
  let t1;
  if ($[0] !== columnFilters) {
    t1 = columnFilters.find(_temp);
    $[0] = columnFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const assetFilter = t1;
  let t2;
  if ($[2] !== columnFilters) {
    t2 = columnFilters.find(_temp2);
    $[2] = columnFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const chainFilter = t2;
  let t3;
  if ($[4] !== assetFilter) {
    t3 = assetFilter ? assetFilter.value as string[] : [];
    $[4] = assetFilter;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== chainFilter) {
    t4 = chainFilter ? chainFilter.value as number[] : [];
    $[6] = chainFilter;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      assetIdsFilter: t3,
      chainIdsFilter: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const filters = t5;
  let t6;
  if ($[11] !== filters || $[12] !== items) {
    let t7;
    if ($[14] !== filters) {
      t7 = item => {
        const withAssetIdFilter = filters.assetIdsFilter.length === 0 || filters.assetIdsFilter.includes(item.vault.asset.id.toLowerCase());
        const withChainIdFilter = !filters.chainIdsFilter?.length || filters.chainIdsFilter.includes(item.vault.asset.chain.id);
        return withAssetIdFilter && withChainIdFilter;
      };
      $[14] = filters;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = items.filter(t7);
    $[11] = filters;
    $[12] = items;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const filteredItems = t6;
  let t7;
  if ($[16] !== filteredItems || $[17] !== filters) {
    t7 = {
      filters,
      filteredItems,
      itemsCount: filteredItems.length
    };
    $[16] = filteredItems;
    $[17] = filters;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
function _temp(f) {
  return f.id === "assetIds";
}
function _temp2(f_0) {
  return f_0.id === "chainIds";
}